import '@accessible360/accessible-slick';
import $ from 'jquery';

const carouselImages = (function () {
  function _init() {
    const $carouselImages = $('.carousel-images').find('.field--field-carousels-images');

    if ($carouselImages && $carouselImages.not('.slick-initialized')) {
      $carouselImages.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Précédent"><span class="patricon' +
          ' patricon-chevron-down" aria-hidden="true"></span></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Suivant"><span class="patricon' +
          ' patricon-chevron-down" aria-hidden="true"></span></button>',
        regionLabel: $carouselImages.parents().data('label'),
        responsive: [
          {
            breakpoint: 755,
            settings: {
              arrows: false
            }
          }
        ]
      });
    }
  }

  return {init: _init};
})();

export default carouselImages;

